import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Col } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { actions } from '../../../context';
import Comment from './Comment';
import NewCommunicationCommentForm from '../../Forms/NewCommunicationCommentForm';

const CommunicationView = ({ refreshCommunications }) => {
    const { communicationId } = useParams();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [communication, setCommunication] = useState({});

    const scrollToBottom = () => {
        var elem = document.getElementById('commentBox');
        if (elem) setTimeout(() => (elem.scrollTop = elem.scrollHeight), 100);
    };

    const refresh = useCallback(
        (scroll = true, read = true) =>
            dispatch(actions.communication.getCommunication(communicationId))
                .then((res) => setCommunication(res?.data || {}))
                .then(() => setLoading(false))
                .then(() => (scroll ? scrollToBottom() : null))
                //read comments
                .then(() =>
                    read
                        ? dispatch(
                              actions.communication.readCommunicationComments(
                                  communicationId
                              )
                          )
                        : null
                )
                .then(() => refreshCommunications())
                .then(() => dispatch(actions.toggle.triggerRefresh())),
        [communicationId, refreshCommunications, dispatch]
    ); // also gets new dashbaord stats

    const onComment = useCallback(() => {
        refreshCommunications();
        refresh();
    }, [refreshCommunications, refresh]);

    // TODO: push this into redux and tie it to a click event instead of useEffect mounting
    useEffect(() => {
        setLoading(true);
        refresh();
    }, [refresh]);

    return (
        <Col lg="7" className="sc-glass sc-rounded p-3">
            {loading ? (
                <h2 className="text-center">Loading...</h2>
            ) : (
                <>
                    <div
                        id="commentBox"
                        className="border-bottom"
                        style={commentListStyles}>
                        {/* TODO: virtualize this? */}
                        {(communication?.comments || []).map((c) => (
                            // TODO: refactor this and pass primitives
                            <Comment key={c.id} comment={c} refresh={refresh} />
                        ))}
                        {/* TODO: maybe rethink this showing up if we don't have to scroll to see all communication comments */}
                        <div className="op-5 text-center my-4 text-14">
                            That's all for now
                        </div>
                    </div>
                    <div className="p-1">
                        {/* TODO: refactor this and pass primitives */}
                        <NewCommunicationCommentForm
                            communication={communication}
                            onComment={onComment}
                        />
                    </div>
                </>
            )}
        </Col>
    );
};
const commentListStyles = {
    minHeight: '450px',
    maxHeight: '450px',
    overflowY: 'scroll',
};
export default CommunicationView;
